export default __webpack_public_path__ + "static/media/desktopHero.ff275f31.png";